module.exports = __webpack_public_path__ + "static/media/logo-lunch-team.2a34be80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo-lunch-team.svg
// module id = 72
// module chunks = 7